(() => {
  const HOVER_CLOSE_DELAY = 200;

  const desktopMql = window.matchMedia('(min-width: 990px)');
  const hoverMql = window.matchMedia('(hover: hover) and (pointer: fine)');
  let activated = false;

  const activate = () => {
    if (activated) return;
    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;

    const headerMenus = Array.from(document.querySelectorAll('.header__inline-menu header-menu'));
    if (!headerMenus.length) return;

    activated = true;
    const groups = [];

    headerMenus.forEach((menu) => {
      const details = menu.querySelector('details.mega-menu');
      if (!details) return;
      const panel = details.querySelector('.mega-menu__content');
      if (!panel) return;
      const summary = details.querySelector('summary');
      if (!summary) return;

      wrapper.appendChild(panel);

      const sync = () => {
        if (details.hasAttribute('open')) {
          panel.setAttribute('data-open', '');
        } else {
          panel.removeAttribute('data-open');
        }
      };
      sync();
      new MutationObserver(sync).observe(details, { attributes: true, attributeFilter: ['open'] });

      menu.close = function close() {
        if (panel.contains(document.activeElement)) return;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      };

      groups.push({ menu, details, panel, summary });
    });

    const closeGroup = (group) => {
      group.details.removeAttribute('open');
      group.summary.setAttribute('aria-expanded', 'false');
    };

    const closeAll = (except) => {
      groups.forEach((group) => {
        if (group === except) return;
        if (group.details.hasAttribute('open')) closeGroup(group);
      });
    };

    groups.forEach((group) => {
      let closeTimer = null;

      const openMenu = () => {
        clearTimeout(closeTimer);
        closeAll(group);
        if (!group.details.hasAttribute('open')) {
          group.details.setAttribute('open', '');
          group.summary.setAttribute('aria-expanded', 'true');
        }
      };

      const closeMenu = () => {
        clearTimeout(closeTimer);
        closeGroup(group);
      };

      const scheduleClose = () => {
        if (!hoverMql.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (group.menu.contains(document.activeElement) || group.panel.contains(document.activeElement)) return;
          if (group.menu.matches(':hover') || group.panel.matches(':hover')) return;
          closeGroup(group);
        }, HOVER_CLOSE_DELAY);
      };

      group.summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (group.details.hasAttribute('open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      const hoverOpen = () => {
        if (!hoverMql.matches) return;
        openMenu();
      };

      group.menu.addEventListener('mouseenter', hoverOpen);
      group.menu.addEventListener('mouseleave', scheduleClose);
      group.panel.addEventListener('mouseenter', hoverOpen);
      group.panel.addEventListener('mouseleave', scheduleClose);

      group.closeMenu = closeMenu;
    });

    document.addEventListener(
      'click',
      (event) => {
        groups.forEach((group) => {
          if (!group.details.hasAttribute('open')) return;
          if (group.menu.contains(event.target) || group.panel.contains(event.target)) return;
          group.closeMenu();
        });
      },
      true
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      groups.forEach((group) => {
        if (!group.details.hasAttribute('open')) return;
        const hadFocus = group.menu.contains(document.activeElement) || group.panel.contains(document.activeElement);
        group.closeMenu();
        if (hadFocus) group.summary.focus();
      });
    });
  };

  const maybeActivate = () => {
    if (desktopMql.matches) activate();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeActivate);
  } else {
    maybeActivate();
  }

  desktopMql.addEventListener('change', maybeActivate);
})();
